import { BaseContainerModel } from "../base-container.model";
import { bl_wms_packing_gendoc_link_RowInterface, bl_wms_packing_gendoc_link_RowClass } from "../../dbschema/index";

export class WMSPackingGendocLinkContainer extends BaseContainerModel {
    bl_wms_packing_gendoc_link: bl_wms_packing_gendoc_link_RowInterface = new bl_wms_packing_gendoc_link_RowClass();
}
